import { render, staticRenderFns } from "./MisPedidos.vue?vue&type=template&id=604a0abe&scoped=true"
import script from "./MisPedidos.vue?vue&type=script&lang=js"
export * from "./MisPedidos.vue?vue&type=script&lang=js"
import style0 from "./MisPedidos.vue?vue&type=style&index=0&id=604a0abe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604a0abe",
  null
  
)

export default component.exports